import PropTypes from 'prop-types'
import { useState, useEffect, useRef } from 'react'
import MenuFiltros from '../MenuFiltros'
import ComponenteError from '../publicaciones/ComponenteError'
import { Paginacion } from '../reutilizables/paginacion/Paginacion'
import { Pedido } from '../reutilizables/pedidos/Pedido'
import * as pedidosService from '../servicios/pedidosService'
import { buscarMedioPago } from '../servicios/publicacionesService'
import * as ventasService from '../servicios/ventasService'
import BordePrincipal from '../ui/BordePrincipal'

const PAGINA_ITEMS = 10

const Pedidos = ({ esVentas }) => {
  const topRef = useRef(null)
  const [itemsPorPagina, setItemsPorPagina] = useState(PAGINA_ITEMS)
  const [paginaActual, setPaginaActual] = useState(1)
  const usuario = parseInt(localStorage.getItem('idUsuario'))
  const [pedidos, setPedidos] = useState([])
  const [sinResultados, setSinResultados] = useState(false)
  const [busqueda, setBusqueda] = useState(false)
  const [mediosPago, setMediosPago] = useState([])

  const fetchData = async (search) => {
    const { data } = await pedidosService.buscarPorUsuario(usuario, search)
    setPedidos(data)
    setSinResultados(data.length === 0)
  }

  useEffect(() => {
    const cargarMediosPago = async () => {
      const { data } = await buscarMedioPago()
      setMediosPago(data || [])
    }
    cargarMediosPago()
  }, [])

  const fetchPedidos = async (search) => {
    const { data } = await ventasService.buscarPorUsuario(usuario, search)
    const pedidosProcesados = data
      .map((pedido) => ({
        ...pedido,
        pedidoItems: Array.isArray(pedido.ventaItems)
          ? pedido.ventaItems.map((element) => ({
              ...element,
              alicuota: element.alicuota,
              cantidad: element.cantidad,
              estados: pedido.estados,
              idPedido: pedido.idPedido,
              compradorNombre: element.nombre,
              vendedorNombre: element.nombre,
              vendedorEMail: element.email,
              vendedorTelefono: element.telefono,
              vendedorCalle: element.calle,
              vendedorCalleAltura: element.calleAltura,
              vendedorPiso: element.piso,
              vendedorCP: element.cp,
              descripcionEstado: element.estadoDescripcion,
              entregaLocalidad: element.localidad,
              entregaCalle: element.calle,
              entregaCalleAltura: element.calleAltura,
              entregaProvincia: element.provincia,
              precioEnvio: element.precioEnvio ?? pedido.precioEnvio ?? 0,
              envioTipo: element.envioTipo ?? pedido.envioTipo ?? '',
              idMedioEnvio: element.idMedioEnvio ?? pedido.idMedioEnvio ?? null
            }))
          : []
      }))
      .sort(
        (a, b) =>
          new Date(b.ventaItems?.[0]?.fechaPedido || 0) -
          new Date(a.ventaItems?.[0]?.fechaPedido || 0)
      )

    setPedidos(pedidosProcesados)
    setSinResultados(pedidosProcesados.length === 0)
  }

  const handleBuscar = async (search) => {
    setBusqueda(!!search)
    setPaginaActual(1)
    const traerPedidos = esVentas ? fetchPedidos : fetchData
    await traerPedidos(search)
  }

  useEffect(() => {
    handleBuscar('')
  }, [esVentas])

  const totalPaginas = Math.ceil(pedidos.length / itemsPorPagina)

  const indexInicio = (paginaActual - 1) * itemsPorPagina
  const indexFin = indexInicio + itemsPorPagina
  const pedidosPaginados = pedidos.slice(indexInicio, indexFin)

  return (
    <>
      <BordePrincipal titulo={esVentas ? 'Mis Ventas' : 'Mis Compras'}>
        <MenuFiltros
          idComponente={21}
          onBuscar={handleBuscar}
          placeholder={'Buscar por Empresa - Producto'}
        />
        <div ref={topRef}></div>
        {!sinResultados ? (
          pedidosPaginados.map((pedido) => (
            <Pedido
              key={pedido.idPedido}
              pedido={pedido}
              esVentas={esVentas}
              mediosPago={mediosPago}
            />
          ))
        ) : !busqueda ? (
          <div className="row">
            <ComponenteError tipo="I" idAviso={22} />
          </div>
        ) : (
          <div className="row">
            <ComponenteError tipo="I" idAviso={7} />
          </div>
        )}
      </BordePrincipal>
      {totalPaginas > 1 && (
        <Paginacion
          totalPaginas={totalPaginas}
          paginaActual={paginaActual}
          onCambioPagina={(num) => {
            setPaginaActual(num)
            topRef.current?.scrollIntoView({ behavior: 'smooth' })
          }}
          itemsPorPagina={itemsPorPagina}
          onCambioItemsPorPagina={(num) => {
            setItemsPorPagina(num)
            setPaginaActual(1)
          }}
        />
      )}
    </>
  )
}

export default Pedidos

Pedidos.propTypes = {
  esVentas: PropTypes.bool.isRequired
}
